import React from 'react';
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';
import {replaceDbValues} from '../utils/utils';
import TabsRenderProp from './TabsRenderProp';
const Fragment = React.Fragment;

const AboutVariable = ({data} ) => {
  return (
    <TabsRenderProp 
    header={() => (
      <React.Fragment>About: {data.data_table.display_name}</React.Fragment>
    )} 
    content={() => (
      <React.Fragment>
        {ReactHtmlParser(replaceDbValues(data))}
      </React.Fragment>
    )}
    />
  )
}

export default AboutVariable;



// WEBPACK FOOTER //
// ./src/components/AboutVariable.js